/**
 * AI互动直播平台 - 主应用组件
 */

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import StreamPage from './components/StreamPage';
import StreamFeed from './components/StreamFeed';
import CreateStreamPage from './components/CreateStreamPage';
import StoryHomePage from './components/StoryHomePage';
import CreateStoryPage from './components/CreateStoryPage';
import StorySessionPage from './components/StorySessionPage';
import StreamAdminPage from './components/admin/StreamAdminPage';
import AdminStreamListPage from './components/admin/AdminStreamListPage';
import VideoGenDebugPage from './components/admin/VideoGenDebugPage';
import InviteCodePage from './components/admin/InviteCodePage';
import AdminLayout from './components/admin/AdminLayout';
import ModelTrialPage from './components/admin/ModelTrialPage';
import AdminLoginPage from './components/auth/AdminLoginPage';
import UserLoginPage from './components/auth/UserLoginPage';
import RequireAdminAuth from './components/auth/RequireAdminAuth';
import RequireUserAuth from './components/auth/RequireUserAuth';
import { initResponsiveOptimization } from './utils/responsive';
import './App.css';

function App() {
  useEffect(() => {
    initResponsiveOptimization();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* C 端公开路由（需登录） */}
          <Route path="/" element={<RequireUserAuth><StreamFeed /></RequireUserAuth>} />
          <Route path="/grid" element={<RequireUserAuth><HomePage /></RequireUserAuth>} />
          <Route path="/mobile" element={<RequireUserAuth><StreamFeed /></RequireUserAuth>} />
          <Route path="/stream/:id" element={<RequireUserAuth><StreamPage /></RequireUserAuth>} />

          {/* C 端需登录路由 */}
          <Route path="/create" element={
            <RequireUserAuth><CreateStreamPage /></RequireUserAuth>
          } />

          {/* C 端登录/注册 */}
          <Route path="/login" element={<UserLoginPage />} />

          {/* 互动故事（公开） */}
          <Route path="/story" element={<StoryHomePage />} />
          <Route path="/story/create" element={<CreateStoryPage />} />
          <Route path="/story/interact/:libraryId" element={<StorySessionPage />} />

          {/* Admin 登录（放在 /admin 之外确保精确匹配） */}
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Admin 受保护路由 — 侧边栏布局 */}
          <Route path="/admin/*" element={
            <RequireAdminAuth><AdminLayout /></RequireAdminAuth>
          }>
            <Route index element={<Navigate to="model-trial" replace />} />
            <Route path="streams" element={<AdminStreamListPage />} />
            <Route path="stream/:id" element={<StreamAdminPage />} />
            <Route path="invites" element={<InviteCodePage />} />
            <Route path="video-debug" element={<VideoGenDebugPage />} />
            <Route path="model-trial" element={<ModelTrialPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
